import { apiRequest } from "@services/apiClient";
import tourLanguagesEndpoints from "@services/tours/tourLanguagesEndpoints";

function normalizeTourLanguagesBody(body) {
  return {
    tour_id: String(body?.tour_id || ""),
    languages: Array.isArray(body?.languages) ? body.languages : [],
  };
}

export async function getTourLanguagesByTourRequest(tourId) {
  const response = await apiRequest(tourLanguagesEndpoints.byTourId(tourId));
  return {
    ...response,
    body: normalizeTourLanguagesBody(response?.body),
  };
}

export async function createTourLanguagesRequest(payload) {
  const response = await apiRequest(tourLanguagesEndpoints.base, {
    method: "POST",
    body: payload,
  });
  return {
    ...response,
    body: normalizeTourLanguagesBody(response?.body),
  };
}

export async function updateTourLanguagesRequest(payload) {
  const response = await apiRequest(tourLanguagesEndpoints.base, {
    method: "PUT",
    body: payload,
  });
  return {
    ...response,
    body: normalizeTourLanguagesBody(response?.body),
  };
}

export async function saveTourLanguagesRequest(payload) {
  try {
    return await updateTourLanguagesRequest(payload);
  } catch (error) {
    if (Number(error?.status) === 404) {
      return createTourLanguagesRequest(payload);
    }
    throw error;
  }
}
